import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account } from "model";

/**
* @class NativeAlert
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.nativeAlerts[0];
* const alert = new NativeAlert(record);
* @property {NUMBER} _id - The id of the NativeAlert.
* @property {STRING} _type - The type of the NativeAlert.
* @property {Account} _account - The account of the NativeAlert.
* @property {STRING} _alertMeWhen - A description of the NativeAlert.
* @property {STRING} _alertMeWhenBalanceIs - A description of the NativeAlert.
* @property {BCMSCurrency} _balanceThresholdAmount - Threshold amount of the NativeAlert.
* @property {ARRAY} _userAccountIDsForPhone - Array of string ids referencing a "userAccount" class instance.
* @property {ARRAY} _userAccountIDsForEmail - Array of string ids referencing a "userAccount" class instance.
* @property {BCMSDate} _createdDateOffset - The date this NativeAlert was created.
* 
*/
export default class NativeAlert extends BCMSRecord {
    _id
    _type
    _account
    _alertMeWhen
    _alertMeWhenBalanceIs
    _balanceThresholdAmount
    _userAccountIDsForPhone
    _userAccountIDsForEmail
    _createdDateOffset

    constructor (record){     
      super(record) 
    }
  }
  NativeAlert.define({
    "recordType":"nativeAlerts",
    "recordIDProp":"id",
    "className" : "NativeAlert",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id of the NativeAlert
       * @property set {NUMBER} - sets the id of the NativeAlert
       * @memberof NativeAlert
       */
      BCMSRecordProperty.mapToString("id", "_id"),

       /** 
       * @name type
       * @instance
       * @property get {NUMBER} - gets the type of the NativeAlert
       * @property set {NUMBER} - sets the type of the NativeAlert
       * @memberof NativeAlert
       */
        BCMSRecordProperty.mapToString("type", "_type"),


        /** 
       * @name account
       * @instance
       * @property get {NUMBER} - gets the id of the NativeAlert
       * @property set {NUMBER} - sets the id of the NativeAlert
       * @memberof NativeAlert
       */
        BCMSRecordProperty.mapToClass("account", "_account", () => Account),

      /** 
       * @name alertMeWhen
       * @instance
       * @property get {NUMBER} - gets the type of the NativeAlert
       * @property set {NUMBER} - sets the type of the NativeAlert
       * @memberof NativeAlert
       */
      BCMSRecordProperty.mapToString("alertMeWhen", "_alertMeWhen"),

        /** 
       * @name alertMeWhenBalanceIs
       * @instance
       * @property get {NUMBER} - gets the type of the NativeAlert
       * @property set {NUMBER} - sets the type of the NativeAlert
       * @memberof NativeAlert
       */
        BCMSRecordProperty.mapToString("alertMeWhenBalanceIs", "_alertMeWhenBalanceIs"),

        /** 
       * @name balanceThresholdAmount
       * @instance
       * @property get {NUMBER} - gets the type of the NativeAlert
       * @property set {NUMBER} - sets the type of the NativeAlert
       * @memberof NativeAlert
       */
        BCMSRecordProperty.mapToCurrency("balanceThresholdAmount", "_balanceThresholdAmount"),

      /** 
       * @name createdDateOffset
       * @instance
       * @property get {NUMBER} - gets the type of the NativeAlert
       * @property set {NUMBER} - sets the type of the NativeAlert
       * @memberof NativeAlert
       */
      BCMSRecordProperty.mapToDate("createdDateOffset", "_createdDateOffset"),

        /**
         * @name userAccountIDsForPhone
         * @instance
         * @property get {ARRAY} - gets the userAccountIDsForPhone
         * @property set {ARRAY} - sets the userAccountIDsForPhone
         * @note We will use these userAccount ids in order to get the phone numbers of those users.
         * Also, the mapToArray currently does not work correctly when the toRecord function is called
         * @memberof NativeAlert
         */
        BCMSRecordProperty.mapTo({
            id: "userAccountIDsForPhone",
            instanceField: "_userAccountIDsForPhone",
            setter: function(value) {
                this._userAccountIDsForPhone = value === undefined || Array.isArray(value)
                    ? value : value.split(",");
            },
            toRecord: function() {
                return this._userAccountIDsForPhone === undefined || this._userAccountIDsForPhone.length === 0
                    ? ""
                    : this._userAccountIDsForPhone.reduce((result, item) => `${ result },${ item }`);
            }
        }),

        /**
         * @name userAccountIDsForEmail
         * @instance
         * @property get {ARRAY} - gets the userAccountIDsForEmail
         * @property set {ARRAY} - sets the userAccountIDsForEmail
         * @note We will use these userAccount ids in order to get the email addresses of those users.
         * Also, the mapToArray currently does not work correctly when the toRecord function is called
         * @memberof NativeAlert
         */
        BCMSRecordProperty.mapTo({
          id: "userAccountIDsForEmail",
          instanceField: "_userAccountIDsForEmail",
          setter: function(value) {
              this._userAccountIDsForEmail = value === undefined || Array.isArray(value)
                  ? value : value.split(",");
          },
          toRecord: function() {
              return this._userAccountIDsForEmail === undefined || this._userAccountIDsForEmail.length === 0
                  ? ""
                  : this._userAccountIDsForEmail.reduce((result, item) => `${ result },${ item }`);
          }
      })
    ]  
})




